import {PlayersStatisticsTableRowValueApiModel} from "./players-statistics.table.row.value.api-model";
import {BaseDomainModel} from "../../../../../../../infrastructure/models/base-domain-model";

export class PlayersStatisticsTableRowValueDomainModel extends BaseDomainModel {
  apiModel: PlayersStatisticsTableRowValueApiModel;

  get columnNum(): Number {
    return this.apiModel.columnNum;
  }

  get value(): Number {
    return this.apiModel.value;
  }
}
